import { Link } from "@mui/material";
import { TbShirtSport } from "react-icons/tb";
import { MdOutlinedFlag } from "react-icons/md";
import { HiOutlineTicket } from "react-icons/hi";

import type { CartManagerState } from "@/global/store/data/purchaseSeats/cartManager";

export const AtlantaHawksLink = () => (
  <Link
    target="_blank"
    sx={{
      fontWeight: 500,
      color: "primary.main",
      textDecoration: "none",
    }}
    href="https://am.ticketmaster.com/hawks/"
  >
    Account Manager
  </Link>
);

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Choose your games.",
    description: "Select the games you wish to attend.",
  },

  {
    icon: <TbShirtSport />,
    title: "Select Your Seats",
    description: "Select the seats you wish to purchase for each game.",
  },

  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description: (
      <>
        Tickets will be available in your Atlanta Hawks <AtlantaHawksLink />.
        Reach out to Live Fan Support for any questions.
      </>
    ),
  },
];

export const faqs = [
  {
    title: "When will I receive my tickets?",
    description:
      "If your reservation is accepted, an Atlanta Hawks representative will be in contact with further information, including ticket delivery details.",
  },
  {
    title: "What happens after I purchase an Atlanta Hawks Suite online?",
    description: (
      <>
        Following your purchase, an Atlanta Hawks representative will follow up
        with you to confirm your order and assist with any questions you have in
        anticipation of your event. Tickets and parking will be added to your
        Atlanta Hawks account where you&apos;ll be able to access them via the
        Atlanta Hawks <AtlantaHawksLink />. All suite tickets are digital.
      </>
    ),
  },
  {
    title: "What is included in my suite?",
    description:
      "If your reservation is accepted, an Atlanta Hawks representative will be in contact with further information, including details regarding parking and food and beverage options.",
  },
];

export const AlantaHawksAdditionalDetailsDisclaimerTC = () => (
  <>
    By entering my name, checking the box above and clicking Submit Request, I
    hereby (i) agree to the{" "}
    <Link target="_blank" href="https://am.ticketmaster.com/hawks/terms">
      Terms of Use
    </Link>{" "}
    (ii) agree that my reservation will not be complete unless and until I
    receive a notice from the Atlanta Hawks confirming whether or not my
    reservation has been accepted in accordance with our agreement.
  </>
);

export function createPerkTotalLabel(cartManager: CartManagerState) {
  return "Add On Balance";
}
